import { SEO, breadcrumbSchema } from "../components/SEO";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { ServiceCard } from "../components/Cards";
import { CTASection } from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { PagePhoto } from "../components/PagePhoto";
import { pagePhotos } from "../content/photos";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";
import { useServices } from "../i18n/content";

export default function ServicesHub() {
  const c = useCopy("servicesHub");
  const cr = useCopy("crumbs");
  const lp = useLp();
  const services = useServices();
  const crumbs = [
    { name: cr.home, path: lp("/") },
    { name: cr.services, path: lp("/servicios/") },
  ];
  const fincas = services.filter((s) => s.category === "fincas");
  const edif = services.filter((s) => s.category === "edificaciones");
  return (
    <>
      <SEO
        title={c.seoT}
        description={c.seoD}
        path="/servicios/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="container-site section-gap !pt-10" data-testid="services-hub">
        <Reveal>
          <p className="tech-label mb-4">{c.kicker}</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">
            {c.h1}
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            {c.intro}
          </p>
        </Reveal>
        <PagePhoto photo={pagePhotos["_hub-servicios"]} className="mt-12 max-w-4xl" />
        <Reveal className="mt-14">
          <h2 className="text-xl sm:text-2xl font-semibold">{c.fincasH}</h2>
        </Reveal>
        <div className="mt-7 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {fincas.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.04}><ServiceCard service={s} index={i} /></Reveal>
          ))}
        </div>
        <Reveal className="mt-14">
          <h2 className="text-xl sm:text-2xl font-semibold">{c.edifH}</h2>
        </Reveal>
        <div className="mt-7 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {edif.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.04}><ServiceCard service={s} index={fincas.length + i} /></Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </>
  );
}
